// One author for the priority spelling, on both sides of the wire.
//
// The wizard shipped "lowest_emissions" while the engine has always keyed on
// "lowest_emission". The backend now canonicalises at its own boundary
// (`engine.normalise_priority`), and the wizard sends the singular. This
// alias stays because SAVED PROJECTS still hold the plural: a buyer reopening
// a project saved before the fix must still see their cell outlined and their
// priority named.
const ALIASES = { lowest_emissions: "lowest_emission" };

export const canonicalPriority = (p) => ALIASES[p] || p;
